import React, {MutableRefObject} from 'react';
import Button from "components/Button";
import {FormikProps} from "formik";
import {useNavigate} from "react-router-dom";
import {SubmitAction} from "../../hooks/useSubmitActionRef";

type Props = {
    formik: FormikProps<any>
    preventSubmit?: boolean
    compact?: boolean
    withoutCancel?: boolean
    onCancel?: () => any
    submitActionRef?: MutableRefObject<SubmitAction>;
}

function FormControls({formik, preventSubmit, compact = false, withoutCancel = false, onCancel, submitActionRef}: Props) {
    const navigate = useNavigate()

    const handleCancel = () => {
        (!!onCancel)? onCancel() : navigate(-1)
    }

    return (
        <div className={`px-4 ${compact? 'py-3' : 'py-5'} bg-gray-50 text-right sm:px-6 sm:rounded-b-md`}>
            <div className="flex space-x-3 justify-end">
                {!withoutCancel &&
                    <Button
                        color={Button.colors.WHITE}
                        onClick={handleCancel}
                        disabled={formik.isSubmitting}
                    >
                        Cancel
                    </Button>
                }

                {/* If we have a submitActionRef we can assume we can show both 'Save' and 'Save and close' buttons */}
                {submitActionRef ?
                  <>
                    <Button
                        type="submit"
                        showSpinner={formik.isSubmitting}
                        disabled={preventSubmit || formik.isSubmitting}
                        onClick={() => submitActionRef.current = 'save'}
                    >
                        Save
                    </Button>

                    <Button
                      type="submit"
                      showSpinner={formik.isSubmitting}
                      disabled={preventSubmit || formik.isSubmitting}
                      onClick={() => submitActionRef.current = 'saveAndClose'}
                    >
                      Save and Close
                    </Button>
                  </> :
                  <Button
                    type="submit"
                    showSpinner={formik.isSubmitting}
                    disabled={preventSubmit || formik.isSubmitting}
                  >
                    Save
                  </Button>
                }
            </div>
        </div>
    );
}

export default FormControls;